import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CanDeactivateFn } from '@angular/router';
import { map, of } from 'rxjs';

import { ConfirmationDialogComponent } from '../components/dialogs/confirmation-dialog/confirmation-dialog.component';
import { ConfirmationDialogData } from '../components/dialogs/confirmation-dialog/models/confirm-dialog-data.interface';
import { IHaveChanges } from '../models/have-changes.interface';

export const unsavedChangesGuard: CanDeactivateFn<IHaveChanges> = (component: IHaveChanges) => {
  const dialog = inject(MatDialog);

  if (!component.haveChanges()) {
    return of(true);
  }

  return dialog
    .open<ConfirmationDialogComponent, Omit<ConfirmationDialogData, 'title'>>(ConfirmationDialogComponent, {
      data: {
        message: 'Confirmation message ',
        confirmLabel: 'Leave',
        cancelLabel: 'Stay',
        icon: 'edit',
        subMessage: 'You have unsaved changes. Are you sure you want to move on?',
      },
    })
    .afterClosed()
    .pipe(map((shouldLeave) => !!shouldLeave));
};
